import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { TravelRegistryType } from '../model/TravelRequestTypes';

interface TravelRegistryTypeBadgeProps {
  registryType: TravelRegistryType;
}

export function TravelRegistryTypeBadge({ registryType }: TravelRegistryTypeBadgeProps) {
  const { t } = useTranslation();
  const name = t(`travel.registryTypeEnum.${registryType}`);

  return (
    <Badge
      size="sm"
      variant="outline"
      color="gray"
      tt="none"
      title={name}
      // The research registry's name is longer than a card is wide, so the badge has to wrap instead of clipping.
      styles={{
        root: { height: 'auto', maxWidth: '100%', paddingBlock: 2 },
        label: { whiteSpace: 'normal', overflow: 'visible' },
      }}
    >
      {name}
    </Badge>
  );
}
